import { render, staticRenderFns } from "./RelationCloneConfig.vue?vue&type=template&id=85573d88&scoped=true"
import script from "./RelationCloneConfig.vue?vue&type=script&lang=ts"
export * from "./RelationCloneConfig.vue?vue&type=script&lang=ts"
import style0 from "./RelationCloneConfig.vue?vue&type=style&index=0&id=85573d88&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85573d88",
  null
  
)

export default component.exports